export class BuilderTabsService {
    static $inject = ['SidebarContentService'];
    constructor(SidebarContentService) {
        this.SidebarContentService = SidebarContentService;
        this.openedSubSidebars = [];
    }
    addSidebar(sidebar) {
        this.openedSubSidebars = this.openedSubSidebars.concat(sidebar);
    }
    closeOpenedSidebars() {
        this.openedSubSidebars.forEach(s => {
            this.SidebarContentService.cleanAndClose(undefined, s);
        });
        this.openedSubSidebars = [];
    }
    validateTab(elementReferenceId, state) {
        const customActionsTabElement = document.getElementById(elementReferenceId);
        if (customActionsTabElement) {
            if (state.$invalidCustomActions) {
                customActionsTabElement.classList.add('invalid-background');
            }
            else {
                customActionsTabElement.classList.remove('invalid-background');
            }
        }
    }
}
BuilderTabsService.$inject = ['SidebarContentService'];
